export default "<svg id=\"minimapa\"></svg>\n";